import { useHistory } from "react-router-dom";
import { Form, Input, message, Button } from "antd";
import { updatePass } from "../../../api/user";
import { formLayout } from "../../../utils/constants";

function NewPassword({ userId, firstName, closeModal }) {
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  // ------- Actualiza contraseña -------
  const sendDataToServer = async (data) => {
    try {
      const response = await updatePass(data, userId);
      message.success(response.message);
      history.replace("/app/usuarios");
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  return (
    <Form
      {...formLayout.formItemLayout}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <h3 className="mb-4">Nueva contraseña para: {firstName}</h3>
      <Form.Item
        label="Contraseña"
        name="password"
        rules={[
          { required: true, message: "La contraseña es necesaria" },
          {
            min: 6,
            message: "La contraseña debe tener como mínimo 6 caracteres",
          },
        ]}
      >
        <Input type="password" />
      </Form.Item>
      <Form.Item
        label="Repetir contraseña"
        name="repeatPassword"
        rules={[
          { required: true, message: "Repetir la contraseña es necesaria" },
        ]}
      >
        <Input type="password" />
      </Form.Item>

      <Form.Item {...formLayout.tailFormItemLayout}>
        <Button type="primary" block htmlType="submit">
          Establecer nueva contraseña
        </Button>
      </Form.Item>
    </Form>
  );
}

export default NewPassword;
